module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICA8cGF0aCBpZD0iY2lyY2xlLXF1YXJ0ZXJzLXNvbGlkIiBkPSJNMTAsMEExMCwxMCwwLDEsMCwyMCwxMCwxMCwxMCwwLDAsMCwxMCwwWm01LjMsMTUuM0wxMCwxMCw0LjcsMTUuM0E3LjUwNSw3LjUwNSwwLDAsMSw0LjcsNC43TDEwLDEwbDUuMy01LjNhNy41MDcsNy41MDcsMCwwLDEsMCwxMC42MDlaIiBmaWxsPSIjODNjOTFlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project-started-icon.svg
// module id = kz4M
// module chunks = 26